import React, { useState, useEffect } from 'react'
import { Script } from 'gatsby'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'

import { ThemeProvider } from 'styled-components'

import { theme } from '../constants/ui/theme'

import GlobalStyles from '../styles/GlobalStyles'
import { PageLayout } from '../styles/PageLayout'

import { getGtmSnippet } from '../constants/scripts/gtm'

import ExclusiveRedirectModal from './ExclusiveRedirectModal'

/**
 * The page layout including all global styles and theme provider,
 * used as a wrapper in gatsby-browser and gatsby-ssr.
 * @param {ComponentProps} props
 * @param {ChildNode} props.children
 * @returns {FunctionComponent}
 */
const Page = ({ children, location }) => {
  const [gtmTag, setGtmTag] = useState(undefined)

  const cookies = new Cookies()

  useEffect(() => {
    const savedTag = cookies.get('gtmTag')

    if (savedTag !== undefined) {
      setGtmTag(savedTag)
    }
  }, [])

  return (
    <>
      {/* Google Tag Manager analytics snippet - loads after cookie consent (accept all or necessary) */}
      {gtmTag !== undefined && <Script dangerouslySetInnerHTML={{ __html: getGtmSnippet(gtmTag) }} />}
      <GlobalStyles />
      <ThemeProvider theme={theme}>
        <PageLayout>{children}</PageLayout>
        <ExclusiveRedirectModal pathname={location.pathname} />
      </ThemeProvider>
    </>
  )
}

Page.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default Page
